export default {
  master_title: 'Modalità marchio - Menu',
  title: 'Menu',
  form: {
    has_internal_product_numbers: {
      label: 'Assegna numeri ai prodotti',
      tooltip:
        'Assegna automaticamente numeri ai prodotti in base alla loro posizione nel menu. Il numero viene stampato sugli scontrini',
    },
  },
  buttons: {
    new_menu: 'Nuovo menu',
    export_menu: 'Esporta menu',
    refresh: 'Aggiorna',
  },
  modals: {
    delete_category: {
      title: 'Elimina {{name}}',
    },
    delete_products: {
      title: 'Eliminare {{count}} prodotti?',
      description: '<strong>{{count}}</strong> verrà rimosso dal menu',
    },
  },
  toasts: {
    failed_to_load_data: 'Caricamento dati fallito',
    failed_to_delete_menu: 'Impossibile eliminare il menu, riprova',
    menu_got_deleted: 'Menu eliminato',
    failed_to_delete_category: 'Impossibile eliminare la categoria, riprova',
    category_got_deleted: 'Categoria eliminata',
    failed_to_delete_products: 'Impossibile eliminare i prodotti, riprova',
    product_got_deleted_one: 'Prodotto eliminato',
    product_got_deleted_other: 'Prodotti eliminati',
    failed_to_generate_product_number: 'Qualcosa è andato storto. Ricarica la pagina e riprova',
    menu_exported: 'Menu esportato',
    failed_to_export_menu: 'Esportazione menu fallita',
  },
};
